/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon33Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g
        stroke={"#292929"}
        strokeLinecap={"round"}
        strokeLinejoin={"round"}
        clipPath={"url(#a)"}
      >
        <path
          d={
            "M13.125 17.5h-8.75a.625.625 0 0 1-.625-.625V5.625A.625.625 0 0 1 4.375 5h6.25l3.125 3.125v8.75a.624.624 0 0 1-.625.625"
          }
        ></path>

        <path
          d={
            "M6.25 5V3.125a.625.625 0 0 1 .625-.625h6.25l3.125 3.125v8.75a.624.624 0 0 1-.625.625H13.75m-6.875-3.125h3.75m-3.75 2.5h3.75"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon33Icon;
/* prettier-ignore-end */
